export default __webpack_public_path__ + "static/media/esd2.3cc3c8e3.jpg";